<template>
  <v-list-item class="pa-2">
    <v-list-item-content @click="handleGoToURL">
      <v-list-item-title>{{ colData.title }}</v-list-item-title>
      <v-list-item-subtitle class="hyperlink-object text-truncate">{{ getHyperLinkContent().linkText }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action @click="handleGoToURL">
      <v-btn disabled small icon>
        <v-icon small>mdi-launch</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>

</template>

<script>
export default {
  name: 'HyperlinkObject',

  props: {
    colData: {
      type: Object,
      default() {
        return {};
      },
    },
    infoObject: {
      type: String,
      default() {
        return {};
      },
    },
  },

  data() {
    return {};
  },

  methods: {
    handleGoToURL() {
      window.open(this.getHyperLinkContent().linkValue, '_blank');
    },
    checkForColumnIDs(object, val) {
      console.log(`CHECK: ${val}`);
      console.dir(object);
      Object.keys(object)
        .forEach((prop) => {
          if (val.indexOf(`#${prop}#`) > -1) {
            console.log(`FOUND: ${prop}`);
            val = val.replace(`#${prop}#`, object[prop]);
          }
        });

      return val;
    },
    getHyperLinkContent() {
      const colData = this.colData;
      const infoObject = this.infoObject;

      let linkObj = {};

      try {
        linkObj = JSON.parse(colData.hyperlink);
      } catch (err) {
        linkObj = {
          linkText: '',
          linkValue: '',
        };
      }

      if (linkObj.linkValue === '#colval#') {
        console.log('USE COL VAL');
        linkObj.linkValue = infoObject[colData.name];
      } else {
        linkObj.linkValue = this.checkForColumnIDs(infoObject, linkObj.linkValue);
      }

      if (!linkObj.linkText) {
        linkObj.linkText = infoObject[colData.name];
      }

      return linkObj;
    },
  },
};
</script>

<style scoped>
.hyperlink-object {
  text-decoration: underline;
}
</style>
